let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("adk1M")).then(() => parcelRequire('iofEW'));